export const MUTATION_GROUP = 'singleSelectFields' as const;
